export default { PACKAGE_VERSION: "0.20.0" };
